import { useTranslation } from "react-i18next";
import { Collapsible, CollapsibleContent, CollapsibleTrigger, cn } from "@tellescope/ui";
import { ChevronDown } from "lucide-react";
import type { ResponsiveLayout } from "../../../../../shared/schema";
import { ResponsiveLayoutEditor } from "../../ResponsiveLayoutEditor";

interface LayoutSectionProps {
  layout: ResponsiveLayout | undefined;
  onChange: (layout: ResponsiveLayout | undefined) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LayoutSection({ layout, onChange, open, onOpenChange }: LayoutSectionProps) {
  const { t } = useTranslation();

  return (
    <Collapsible open={open} onOpenChange={onOpenChange} className="border-t pt-4 mt-4">
      <CollapsibleTrigger className="flex items-center gap-2 w-full text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
        <ChevronDown className={cn("h-4 w-4 transition-transform", open && "rotate-180")} />
        {t("Layout Settings")}
        {layout && <span className="text-xs bg-primary/10 text-primary px-1.5 py-0.5 rounded">{t("Custom")}</span>}
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-4">
        <ResponsiveLayoutEditor layout={layout} onChange={onChange} />
      </CollapsibleContent>
    </Collapsible>
  );
}
